import { makeImmutable } from "../core/makeImmutable";
export class PMoney {
    constructor(localizationProvider, value) {
        this.localizationProvider = localizationProvider;
        this._value = value;
        makeImmutable(this);
    }
    /*
     * Null is returned when money equals zero - this is convenient for UI
     */
    get dualPriceValue() {
        switch (this._value.type) {
            case "null":
                return null;
            case "value":
                return this.localizationProvider.formatDualPrice(this._value.value);
            case "range":
                return this.localizationProvider.formatDualPriceRange(this._value.min, this._value.max);
        }
    }
    get mainPriceValue() {
        switch (this._value.type) {
            case "null":
                return null;
            case "value":
                return this.localizationProvider.formatMainPrice(this._value.value);
            case "range":
                return this.localizationProvider.formatMainPriceRange(this._value.min, this._value.max);
        }
    }
    /*
     * Grand price is a singular price, null when range
     */
    get grandPriceValue() {
        switch (this._value.type) {
            case "null":
                return null;
            case "value":
                return this.localizationProvider.formatMainPrice(this._value.value);
            case "range":
                return null;
        }
    }
    get alternativePriceValue() {
        if (!this.localizationProvider.hrkDualPricesEnabled) {
            return null;
        }
        switch (this._value.type) {
            case "null":
                return null;
            case "value":
                return this.localizationProvider.formatAlternativePrice(this._value.value);
            case "range":
                return this.localizationProvider.formatAlternativePriceRange(this._value.min, this._value.max);
        }
    }
}
